"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conditionallyIncludeSigner = exports.removeSignerDuplicates = void 0;
const web3_js_1 = require("@solana/web3.js");
const object_1 = require("./object");
// TODO: this can use some testing...
const removeSignerDuplicates = (signers) => (0, object_1.removeDuplicates)(signers, (s) => JSON.stringify([...s.secretKey]), (s) => {
    return web3_js_1.Keypair.fromSecretKey(new Uint8Array(JSON.parse(s)));
});
exports.removeSignerDuplicates = removeSignerDuplicates;
const conditionallyIncludeSigner = (signers, conditionalSigner) => {
    if (conditionalSigner.secretKey) {
        return [...signers, conditionalSigner];
    }
    return signers;
};
exports.conditionallyIncludeSigner = conditionallyIncludeSigner;
